var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeliveryMotor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 512,
    height: 512,
    x: 0,
    y: 0,
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffdc6e",
    d: "M18.907 225.85h104.019c6.549 0 11.907-5.358 11.907-11.907V109.924c0-6.549-5.358-11.908-11.907-11.908H18.907C12.358 98.016 7 103.375 7 109.924v104.019c0 6.549 5.358 11.907 11.907 11.907z",
    opacity: 1,
    "data-original": "#ffdc6e",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffca28",
    d: "M112.151 225.85h10.775c6.549 0 11.907-5.358 11.907-11.907V109.924c0-6.549-5.358-11.908-11.907-11.908h-10.775z",
    opacity: 1,
    "data-original": "#ffca28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7524b",
    d: "M89.91 145.895V98.016H51.924v47.879c0 3.77 2.595 6.844 5.777 6.844h26.434c3.181.001 5.775-3.074 5.775-6.844zM363.69 230.906h52.351l24.911 115.169H363.69z",
    opacity: 1,
    "data-original": "#f7524b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cb413d",
    d: "M363.69 230.906h52.351l10.076 46.584-62.427-23.569z",
    opacity: 1,
    "data-original": "#cb413d"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404049",
    d: "M75.52 266.356h165.352c11.041 0 20.073-9.032 20.073-20.072 0-11.041-9.032-20.073-20.073-20.073H95.594c-11.041 0-20.074 9.032-20.074 20.073zM196.822 401.53c0 41.952-34.009 75.961-75.961 75.961S44.9 443.483 44.9 401.53z",
    opacity: 1,
    "data-original": "#404049"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0fc",
    d: "M158.698 401.53c0 20.897-16.94 37.837-37.837 37.837s-37.837-16.94-37.837-37.837z",
    opacity: 1,
    "data-original": "#f0f0fc"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404049",
    d: "M490.27 401.53c0 41.952-34.009 75.961-75.961 75.961s-75.961-34.009-75.961-75.961z",
    opacity: 1,
    "data-original": "#404049"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f0f0fc",
    d: "M452.145 401.53c0 20.897-16.94 37.837-37.837 37.837-20.896 0-37.837-16.94-37.837-37.837z",
    opacity: 1,
    "data-original": "#f0f0fc"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7524b",
    d: "M30.169 401.53h213.732V257.981H101.944c-39.476 0-71.775 32.298-71.775 71.774z",
    opacity: 1,
    "data-original": "#f7524b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f7524b",
    d: "M225.708 348.672h126.506v52.859H225.708z",
    opacity: 1,
    "data-original": "#f7524b"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ef444e",
    d: "m428.847 172.657-55.338 8.4a11.488 11.488 0 0 0-9.819 11.422v45.719l65.157 9.89c17.24 2.617 31.598-16.972 31.598-37.715 0-19.793-13.862-40.407-31.598-37.716z",
    opacity: 1,
    "data-original": "#ef444e"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdc6e",
    d: "M429.583 248.186c16.911 1.959 30.862-17.365 30.862-37.813 0-19.519-13.48-39.834-30.862-37.813z",
    opacity: 1,
    "data-original": "#ffdc6e",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e14844",
    d: "M120.861 310.839c50.088 0 90.692 40.604 90.692 90.692H30.169c0-50.088 40.604-90.692 90.692-90.692z",
    opacity: 1,
    "data-original": "#e14844"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdc6e",
    d: "m151.257 184.496 49.03 23.338 61.25-29.865 37.882 30.195 86.623 25.487 12.342-20.762c-28.123-9.39-50.715-18.519-78.949-29.736l-21.26-27.377s.699-25.214-13.663-38.405-14.451-13.523-14.451-13.523c-77.239 2.903-106.712 38.914-118.804 80.648z",
    opacity: 1,
    "data-original": "#ffdc6e",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#484a50",
    d: "M388.452 237.482c8.654 0 15.712-7.058 15.712-15.712s-7.058-15.712-15.712-15.712-15.712 7.058-15.712 15.712 7.058 15.712 15.712 15.712zM157.132 236.307l105.222 36.337-.973 92.909h34.13l3.008-109.525c.285-10.361-5.651-19.261-15.102-23.512l-128.814-57.943-11.336 25.2c-6.233 13.857-.501 31.575 13.865 36.534z",
    opacity: 1,
    "data-original": "#484a50"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffdc6e",
    d: "m261.308 360.917-.14 11.84c-.117 9.974 8.406 18.055 18.381 17.893l13.655-.223 16.646-.107c7.162-.046 12.965-5.925 12.92-13.086l-.012-1.746c-.048-7.558-5.853-13.798-13.208-14.571h-14.225z",
    opacity: 1,
    "data-original": "#ffdc6e",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffca28",
    d: "m287.672 390.517 5.532-.091 16.646-.107c7.162-.046 12.965-5.925 12.92-13.086l-.012-1.746c-.048-7.558-5.853-13.798-13.208-14.571h-21.877v29.601z",
    opacity: 1,
    "data-original": "#ffca28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e14844",
    d: "M414.308 310.839c50.087 0 90.692 40.604 90.692 90.692H323.617c0-50.088 40.604-90.692 90.691-90.692z",
    opacity: 1,
    "data-original": "#e14844"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cb413d",
    d: "M120.861 310.839c50.088 0 90.692 40.604 90.692 90.692h-39.831c-1.271-41.897-29.203-77.086-67.406-89.181a91.09 91.09 0 0 1 16.545-1.511zM414.308 310.839c50.088 0 90.692 40.604 90.692 90.692h-39.831c-1.271-41.897-29.203-77.086-67.406-89.181a91.107 91.107 0 0 1 16.545-1.511z",
    opacity: 1,
    "data-original": "#cb413d"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#404049",
    d: "M388.452 206.059c8.677 0 15.711 7.034 15.711 15.711s-7.034 15.711-15.711 15.711c-1.07 0-2.115-.107-3.125-.311 7.18-1.449 12.586-7.793 12.586-15.4s-5.406-13.951-12.586-15.4a15.764 15.764 0 0 1 3.125-.311zM203.662 206.188l70.756 31.828c9.451 4.251 15.351 13.151 15.102 23.513l-2.393 99.389h8.512l2.881-104.889c.232-9.552-4.766-17.862-12.953-22.432h-.001a28.002 28.002 0 0 0-.419-.229h-.001a28.323 28.323 0 0 0-1.729-.852l-128.814-57.943-3.55 7.893z",
    opacity: 1,
    "data-original": "#404049"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffca28",
    d: "M200.24 120.423c15.731-6.532 35.196-10.668 59.321-11.575 3.807 13.397 14.453 26.94 25.98 34.653 2.355 9.315 2.134 17.275 2.134 17.275l21.26 27.377c21.955 8.722 43.858 17.523 66.152 25.352a15.778 15.778 0 0 1 7.168-6.178c-21.149-7.521-41.963-15.889-62.82-24.175l-21.26-27.377s.211-7.619-1.984-16.672c-1.799-7.416-5.212-15.793-11.679-21.733-14.362-13.191-14.451-13.523-14.451-13.523-.774.029-1.543.062-2.307.097-28.671 1.34-50.638 7.318-67.514 16.479z",
    opacity: 1,
    "data-original": "#ffca28"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f6dccd",
    d: "M325.428 46.393c23.968 2.331 41.509 23.651 39.178 47.619-2.331 23.969-23.651 41.51-47.619 39.179-23.969-2.331-41.51-23.651-39.179-47.62l43.4 4.221z",
    opacity: 1,
    "data-original": "#f6dccd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#e14844",
    d: "M326.557 34.772c25.359 2.466 45.041 21.699 49.144 45.655.628 3.668-.393 7.091-2.927 9.817s-5.875 3.992-9.579 3.632l-30.49-2.965c-6.333-.616-12.001 4.047-12.617 10.38l-2.964 30.484c-.361 3.706-2.249 6.742-5.413 8.704s-6.723 2.304-10.203.98c-22.713-8.645-37.788-31.662-35.323-57.017 2.956-30.386 29.986-52.625 60.372-49.67z",
    opacity: 1,
    "data-original": "#e14844"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#cb413d",
    d: "M326.557 34.772c25.359 2.466 45.041 21.699 49.144 45.655.628 3.668-.393 7.091-2.927 9.817-2.207 2.374-5.027 3.641-8.166 3.69.004-.255.01-.51.01-.766 0-29.824-24.176-54-54-54-5.963 0-11.698.969-17.061 2.753a55.03 55.03 0 0 1 33-7.149z",
    opacity: 1,
    "data-original": "#cb413d"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliveryMotor);
export default __webpack_public_path__ + "static/media/DeliveryMotor.1db1952318d4a0270944acb0b9da7295.svg";
export { ForwardRef as ReactComponent };